"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _reactRouter = require("react-router");

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _Form = require("@quixeltools/quixel-ui-library/dist/components/common/website/Form");

var _Form2 = _interopRequireDefault(_Form);

var _PaymentTab = require("@quixeltools/quixel-ui-library/dist/components/common/checkout/PaymentTab");

var _PaymentTab2 = _interopRequireDefault(_PaymentTab);

var _Checkbox = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Checkbox");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _TextInput = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextInput");

var _TextInput2 = _interopRequireDefault(_TextInput);

var _TextButton = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextButton");

var _TextButton2 = _interopRequireDefault(_TextButton);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _PaymentFormSection = require("@quixeltools/quixel-ui-library/dist/components/common/checkout/PaymentFormSection");

var _PaymentFormSection2 = _interopRequireDefault(_PaymentFormSection);

var _AddressFormFields = require("@quixeltools/quixel-ui-library/dist/components/common/checkout/AddressFormFields");

var _AddressFormFields2 = _interopRequireDefault(_AddressFormFields);

var _CreditCardFormFields = require("@quixeltools/quixel-ui-library/dist/components/common/checkout/CreditCardFormFields");

var _CreditCardFormFields2 = _interopRequireDefault(_CreditCardFormFields);

var _PayPalPaymentBox = require("./PayPalPaymentBox");

var _PayPalPaymentBox2 = _interopRequireDefault(_PayPalPaymentBox);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addressFormFields = (0, _glamor.css)({
  marginBottom: (0, _css.unitRem)(2)
});

var paymentFormFields = (0, _glamor.css)({
  marginBottom: (0, _css.unitRem)(2)
});

var footer = (0, _glamor.css)(_css.clearfix, {
  display: "block",
  // alignItems: 'center',
  // justifyContent: 'space-between',
  marginTop: (0, _css.unitRem)(1.5)
});

var confirmButton = (0, _glamor.css)({
  display: "inline",
  //position: 'absolute',
  //right: 0,
  float: "right"
});

var tos = (0, _glamor.css)({
  color: _css.colors.gray,
  fontSize: "1em"
});

var tosLink = (0, _glamor.css)({
  fontSize: "1em",
  "& a": {
    paddingLeft: "0px"
  }
});

var promoCodeMessage = (0, _glamor.css)({
  display: "block",
  color: _css.colors.gray,
  marginTop: "0.375em"
});

var backButton = (0, _glamor.css)({
  float: "left",
  color: _css.colors.gray,
  //display: 'flex',
  alignItems: "center",
  cursor: "pointer",
  //paddingTop: '1.05em',
  //paddingBottom: '1.2em',
  fontWeight: 300,
  textDecoration: "none",
  fontSize: (0, _css.unitRem)(1),

  ":hover": {
    color: _css.colors.white,
    "& span": {
      borderLeftColor: _css.colors.white,
      borderBottomColor: _css.colors.white
    }
  }
});

var backButtonContent = (0, _glamor.css)({
  marginLeft: "6px",
  ":after": {
    content: '"Back"'
  }
}, (0, _css.minWidth)(_css.breakpoints.mediumlarge)({
  ":after": {
    content: '"Back to settings"'
  }
}));

var leftArrow = (0, _glamor.css)({
  display: "inline-block",
  width: (0, _css.unitRem)(0.625),
  height: (0, _css.unitRem)(0.625),
  border: "none",
  borderLeft: "1px solid " + _css.colors.gray,
  borderBottom: "1px solid " + _css.colors.gray,
  transform: "rotate(45deg)"
});

var fields = (0, _glamor.css)({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "space-between"
});

var promoCodeField = (0, _glamor.css)({
  marginTop: "1.5em",
  flexBasis: "100%"
});

/* eslint-disable jsx-a11y/label-has-for */

var PaymentForm = function (_React$Component) {
  (0, _inherits3.default)(PaymentForm, _React$Component);

  function PaymentForm(props) {
    (0, _classCallCheck3.default)(this, PaymentForm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PaymentForm.__proto__ || (0, _getPrototypeOf2.default)(PaymentForm)).call(this, props));

    _this.state = {
      paymentType: "cc"
    };
    return _this;
  }

  (0, _createClass3.default)(PaymentForm, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var flag = true,
          elem = document.getElementById("checkout-price"),
          scrollTo = void 0;
      elem = document.getElementById("checkout-price");

      scrollTo = elem.parentNode.clientHeight - elem.clientHeight + 77;
      elem.style.width = "22.3%";
      elem.style.maxWidth = "320px";
      if (window.scrollY + 60 > scrollTo) {
        elem.style.position = "absolute";
        if (flag === true) {
          elem.style.top = scrollTo + "px";
          flag = false;
        }
      } else if (window.scrollY + 60 <= scrollTo) {
        if (elem.getBoundingClientRect().top + 35 - window.scrollY < 0) {
          elem.style.width = "22.3%";
          elem.style.top = "60px";
          elem.style.position = "fixed";
          flag = true;
        } else {
          elem.style.width = "unset";
          elem.style.top = "unset";
          elem.style.position = "unset";
        }
      }
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var paymentType = this.state.paymentType;

      var formID = paymentType === "cc" ? "creditCardForm" : "paypalForm";
      return _react2.default.createElement(
        _Form2.default,
        { id: formID, onSubmit: props.handleSubmit, error: props.error },
        _react2.default.createElement(
          _PaymentFormSection2.default,
          { title: "Billing Details" },
          _react2.default.createElement(
            "div",
            { className: addressFormFields },
            _react2.default.createElement(_AddressFormFields2.default, {
              disabled: props.makingPayment,
              fields: props.fields,
              lockCountryAndVat: props.lockCountryAndVat,
              validatingVat: props.validatingVat
            })
          ),
          _react2.default.createElement(_Checkbox2.default, (0, _extends3.default)({
            className: (0, _glamor.css)({
              "& span": {
                color: _css.colors.white
              }
            }),
            disabled: props.makingPayment,
            label: "Subscribe to our newsletter"
          }, props.fields.subscribe))
        ),
        _react2.default.createElement(
          _PaymentFormSection2.default,
          {
            title: "Payment Details",
            credit: " ",
            braintreeLink: props.braintreeLink
          },
          _react2.default.createElement(
            "div",
            {
              style: {
                maxWidth: "640px",
                textAlign: "center",
                margin: "auto",
                marginTop: 38
              }
            },
            _react2.default.createElement(
              "div",
              null,
              _react2.default.createElement(
                _PaymentTab2.default,
                {
                  active: this.state.paymentType === "cc" ? 0 : 1,
                  onSetActiveTab: function onSetActiveTab(tab) {
                    _this2.setState({ paymentType: tab == 0 ? "cc" : "paypal" });
                    props.fields.paymentMethod.onChange({
                      value: tab == 0 ? "cc" : "paypal"
                    });
                  },
                  styles: { background: "rgba(95,95,95,0.0)" }
                },
                _react2.default.createElement(
                  _PaymentTab.Tab,
                  null,
                  _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement("img", {
                      className: (0, _glamor.css)({
                        height: (0, _css.unitRem)(1),
                        marginTop: "0.7rem"
                      }),
                      src: "/icons/cc.png",
                      alt: "credit card"
                    })
                  )
                ),
                _react2.default.createElement(
                  _PaymentTab.Tab,
                  null,
                  _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement("img", {
                      className: (0, _glamor.css)({
                        height: (0, _css.unitRem)(1),
                        marginTop: "0.7rem"
                      }),
                      src: "/icons/paypal.png",
                      alt: "paypal"
                    })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            "div",
            { className: paymentFormFields },
            props.fields.paymentMethod.value === "cc" && _react2.default.createElement(_CreditCardFormFields2.default, {
              creditCardPrepare: this.props.creditCardPrepare,
              error: this.props.paypalPaymentBoxError,
              disabled: props.makingPayment,
              fields: props.fields
            }),
            props.fields.paymentMethod.value === "paypal" && _react2.default.createElement(_PayPalPaymentBox2.default, {
              error: this.props.paypalPaymentBoxError,
              paypalContainerId: props.paypalContainerId,
              paypalEmail: props.paypalEmail
            }),
            props.renderCaptcha(props.fields.captcha),
            props.showPromoCode && _react2.default.createElement(
              "div",
              { className: fields },
              _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
                errorBelow: true,
                placeholder: "Please enter Promo code here...",
                className: promoCodeField,
                disabled: props.makingPayment || props.isAnnualSubscription,
                label: "Promo Code",
                loading: props.validatingPromoCode,
                icon: "acquire",
                isValidResult: props.promoCodeMessage,
                onChange: function onChange(event) {
                  props.fields.validatingField.onChange("promoCode");
                  props.fields.isVatValid.onChange(props.fields.vatNo.valid);
                  props.fields.promoCode.onChange(event);
                }
              }, _ramda2.default.omit(["onChange"], props.fields.promoCode)))
            ),
            props.showPromoCode && props.promoCodeMessage && _react2.default.createElement(
              "span",
              { className: promoCodeMessage },
              props.promoCodeMessage
            ),
            props.isAnnualSubscription && _react2.default.createElement(
              "span",
              { className: promoCodeMessage },
              "* Promo code do not apply to annual subscriptions"
            )
          ),
          _react2.default.createElement(
            _Checkbox2.default,
            (0, _extends3.default)({
              className: (0, _glamor.css)({ "& span:": { top: 0 } }),
              disabled: props.makingPayment,
              simpleError: true
            }, props.fields.acceptTos),
            _react2.default.createElement(
              "span",
              { className: tos },
              "By completing this purchase you accept our\xA0",
              _react2.default.createElement(_TextButton2.default, {
                className: tosLink,
                mode: "small-gray-underlined",
                href: "/terms",
                label: "Terms of Service",
                newWindow: true
              })
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: footer },
          props.backLink && _react2.default.createElement(
            "div",
            { className: (0, _glamor.css)({ float: "left", paddingTop: "0.5em" }) },
            _react2.default.createElement(
              _reactRouter.Link,
              {
                className: backButton,
                to: {
                  pathname: props.backLink,
                  state: { comingBackFromNextPage: true }
                }
              },
              _react2.default.createElement("span", { className: leftArrow }),
              _react2.default.createElement("span", { className: backButtonContent })
            )
          ),
          _react2.default.createElement(_Button2.default, {
            type: "submit",
            className: confirmButton,
            mode: "secondary",
            label: "Confirm Purchase",
            disabled: props.makingPayment,
            loading: props.makingPayment
          })
        )
      );
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      //  updatePrice(countryCode, state, city, postalCode, vatNo, isVatValid) {
      // console.log(this.props.fields)
      this.props.updatePrice(this.props.fields.country.value, this.props.fields.state.value, this.props.fields.city.value, this.props.fields.postalCode.value, this.props.fields.vatNo.value, this.props.fields.isVatValid.value);
    }
  }]);
  return PaymentForm;
}(_react2.default.Component);

exports.default = PaymentForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PaymentForm/component/PaymentForm.jsx
// module id = 2508
// module chunks = 0